import type { SiteConfigFn } from '@wix/thunderbolt-vsm-api'
import type { PanoramaSiteConfig } from '../types'

const panoramaSiteConfig: SiteConfigFn<PanoramaSiteConfig> = ({ api }) => {
	const shouldLoadSiteFeature = api.features.isActive('platform')

	return {
		shouldLoadSiteFeature,
		shouldLoadSiteConfig: false,
		siteConfig: null,
	}
}

const name = 'panorama'

export const config = { site: panoramaSiteConfig, name }
